import React from 'react';
import ClassNames from 'classnames';

class ProgressBar extends React.Component {
    render() {
        let classes, style;
        if(typeof this.props.progress === 'undefined') {
            classes = {indeterminate: true};
        } else {
            classes = {determinate: true};
            style = {
                width: this.props.progress + '%'
            };
        }

        return (
            <div className={ClassNames('progress', this.props.className)}>
                <div className={ClassNames(classes)} style={style}></div>
            </div>
        );
    }
}

ProgressBar.propTypes = {
    /**
     * A number between 0..100 that indicates the current progress,
     * when provided, a determinate bar with the progress is displayed,
     * otherwise a indeterminate bar is shown
     */
    progress: React.PropTypes.number,
    className: React.PropTypes.string
};

export default ProgressBar;